import React, { useState, useContext } from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"

import { getLinkPropsFromReference } from '../../utils/link'
import { RichLinks, RichContent } from '../../utils/html'

import { getTheme, THEME_GREY } from '../../theme/theme'

import PageMetaContext from '../../context/page-meta-context';

import SectionContainer from '../section-container'

import { Inner, HeadingContainer, QuestionsContainer, QuestionList, QuestionContainer, Question, Answer, Heading, ExpandArrow } from './questions.styles'

const QuestionBlock = ({question,answer}) => {
	const [active, setActive] = useState(false);

	const handleClick = event => {
		event.preventDefault();
		setActive(!active);
	}

	return (
		<QuestionContainer active={active} itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
			<Question itemProp="name" onClick={handleClick}>
				<RichContent render={question} />
				<ExpandArrow width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M5.58816 5.872L10.6602 0.784L9.89216 -3.35704e-08L5.58816 4.304L1.28416 -4.09838e-07L0.500155 0.768L5.58816 5.872Z" />
				</ExpandArrow>
			</Question>
			<Answer itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
					<div itemProp="text">
					<RichContent render={answer} />
				</div>
			</Answer>
		</QuestionContainer>
	)
}

const Questions = ({heading,items,overlap,overlapSmall,color,count}) => {
	const meta = useContext(PageMetaContext);
	return (
		<ThemeProvider theme={(theme) => ({...theme,...getTheme(color)})}>
			<SectionContainer overlap={overlap} overlapSmall={overlapSmall}>
				<Inner itemScope itemType="https://schema.org/FAQPage">
					<HeadingContainer>
						<Heading><RichContent render={heading} /></Heading>
					</HeadingContainer>
					<QuestionsContainer>
						<QuestionList>
							{items.map((item,index) => <QuestionBlock key={index} {...item} />)}
						</QuestionList>
					</QuestionsContainer>
				</Inner>
			</SectionContainer>
		</ThemeProvider>
	)
}

export default Questions;